/* eslint-disable react-hooks/exhaustive-deps */
import * as L from 'leaflet';
import { useCallback, useEffect, useState } from "react";
import {
  getBounds,
  notEqualBounds,
  defaultMapConfig,
  useMapConfig,
} from '../../../../components/SubjectsMap/helper';

const locationIcon = '/assets/images/dashboard/map-icons/amp_location_pin.svg';

const useMapHelper = ({ scl, container, t }) => {
  const { TILE_LAYER_URL, MAP_TOKEN } = useMapConfig();
  const [sclMarker, setSclMarker] = useState();
  const [sclPopover, setSclPopover] = useState();
  const [mapRef, setMapRef] = useState();
  const [initDone, setInitDone] = useState(false);
  const [lastBounds, setLastBound] = useState(false);

  // Map control handlers
  const zoomHandler = useCallback(() => {
    if (mapRef) {
      mapRef.setZoom(mapRef.getZoom() + 1);
    }
  }, [mapRef]);

  const zoomOutHandler = useCallback(() => {
    if (mapRef) {
      mapRef.setZoom(mapRef.getZoom() - 1)
    }
  }, [mapRef]);

  const moveUpHandler = useCallback(() => {
    if (mapRef) {
      const center = mapRef.getCenter();
      const value = 30 / mapRef.getZoom();
      mapRef.panTo(new L.LatLng(center.lat + value, center.lng));
    }
  }, [mapRef]);

  const moveDownHandler = useCallback(() => {
    if (mapRef) {
      const center = mapRef.getCenter();
      const value = 30 / mapRef.getZoom();
      mapRef.panTo(new L.LatLng(center.lat - value, center.lng));
    }
  }, [mapRef]);

  const createPopover = ({
    popover,
    data,
    setPopover,
    title,
  }) => {
    const content = scl.name;
    if (popover) {
      popover.setContent(content);
      return;
    }
    const p = L.popup({
      closeOnClick: true,
      autoClose: false,
    })
      .setContent(content);
    setPopover(p);
  };

  useEffect(() => {
    if (mapRef) {
      const bounds = getBounds({ scl });
      if (bounds.length > 1 && notEqualBounds(bounds, lastBounds)) {
        // mapRef.fitBounds(bounds);
        setLastBound(bounds);
        zoomOutHandler();
      } else if (bounds.length === 1) {
        // mapRef.setView(bounds[0], 4);
        setLastBound(bounds);
      }
    }
  }, [mapRef, scl]);

  const createInstance = () => {
    if (container.current) {
      var c = L.DomUtil.get(document.getElementById(container.current));
      if (c != null) {
        c._leaflet_id = null;
      }
      const map = L.map(container.current, {
        ...defaultMapConfig,
        center: scl.coordinates ? [scl.coordinates.lat, scl.coordinates.lng] : [0, 0],
        zoom: 3,
        scrollWheelZoom: false,
      });
      L.control.scale().addTo(map);
      L.tileLayer(TILE_LAYER_URL, { access_token: MAP_TOKEN }).addTo(map);
      return map;
    }
  };

  useEffect(() => {
    if (!mapRef) {
      setMapRef(createInstance());
    }
  }, [scl]);

  useEffect(() => {
    if (sclMarker && sclPopover) {
      sclMarker.bindPopup(sclPopover).openPopup();
    }
  }, [sclMarker, sclPopover]);

  useEffect(() => {
    if (mapRef && !initDone && scl && scl.coordinates) {
      let sclM;
      if (scl && Object.keys(scl).length > 0 && scl.coordinates) {
        const coords = L.latLng(scl.coordinates.lat, scl.coordinates.lng)
        sclM = L.marker(coords, {
          icon: L.icon({
            iconUrl: locationIcon,
            iconSize: [36, 36],
          }),
          zIndexOffset: 100,
        }).addTo(mapRef);
        createPopover({
          setPopover: (val) => setSclPopover(val),
          popover: sclPopover,
          data: scl,
          title: 'Mine Site',
        });
      }
      setSclMarker(sclM);
      setInitDone(true);
    }
  }, [mapRef, scl]);

  const removeMarker = useCallback((ids) => {
    mapRef.eachLayer((layer) => {
      if (ids.includes(layer._leaflet_id)) {
        mapRef.removeLayer(layer);
      }
    });
  }, [mapRef]);

  useEffect(() => {
    if (mapRef) {
      if (scl && Object.keys(scl).length && scl.coordinates) {
        if (sclMarker) {
          sclMarker.setLatLng(scl.coordinates);
          createPopover({
            setPopover: (val) => setSclPopover(val),
            popover: sclPopover,
            data: scl,
            title: 'Mine Site',
          });
        }
      } else if (sclMarker) {
        removeMarker([sclMarker._leaflet_id]);
        setSclMarker(null);
      }
    }
  }, [scl]);

  return {
    zoomHandler,
    zoomOutHandler,
    moveDownHandler,
    moveUpHandler,
  };
};

export default useMapHelper;
